import { max, setWith } from "lodash";
import { getCyclicIndex, mod } from "./basicAlgebra";
import {
  infoSettingsFrameIndexToLayerFrameObject,
  isValidPercentage,
} from "./general";

export function inferBounds({ input, frameCount }) {
  const out = {};
  for (const layer of Object.keys(input)) {
    out[layer] = inferBoundsInLayer(Object.keys(input[layer]), frameCount);
  }
  return out;
}

export function inferBoundsInLayer(frames, frameCount) {
  // gets an array of frame indices and number of frames
  // returns pair of adjacent frame indices that has the longest
  // gap between them
  frames.sort((a, b) => a - b);
  const gapLength = frames.map((_, i) =>
    mod(
      frames[getCyclicIndex(frames, i)] - frames[getCyclicIndex(frames, i - 1)],
      frameCount
    )
  );
  const longestGapLength = max(gapLength);
  const i = gapLength.indexOf(longestGapLength);
  const b = frames[i];
  const a = frames[getCyclicIndex(frames, i - 1)];
  return [b, a];
}

export function spinHotspotsToAlgorithmState(framesOneBasedSequential, N) {
  // N is frame count
  const out = {};
  for (let oneBasedFrameIndex of Object.keys(framesOneBasedSequential)) {
    let { layer, frame } = infoSettingsFrameIndexToLayerFrameObject(
      oneBasedFrameIndex,
      N
    );
    const pointer = framesOneBasedSequential[oneBasedFrameIndex]?.pointer;
    if (!pointer) {
      break;
    }
    let { x, y } = pointer;
    x = parseFloat(x);
    y = parseFloat(y);
    if (!isValidPercentage(x) || !isValidPercentage(y)) {
      break;
    }
    setWith(out, [layer, frame], { layer, frame, x, y }, Object);
  }
  return out;
}
